module.exports = __webpack_public_path__ + "img/11.c097a0c5.jpg";